import { render, staticRenderFns } from "./MediaForm.vue?vue&type=template&id=c62ffb88&scoped=true&"
import script from "./MediaForm.vue?vue&type=script&lang=js&"
export * from "./MediaForm.vue?vue&type=script&lang=js&"
import style0 from "./MediaForm.vue?vue&type=style&index=0&id=c62ffb88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62ffb88",
  null
  
)

export default component.exports